import { Box } from "@mui/material";
import PromoCodeForm from "./PromoCodeForm";

const PromoRightForm: React.FC = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                color: "#000",
                gap: 2,
            }}
        >
            {/* 🔸 Logo */}
            <Box
                component="img"
                draggable="false"
                src="/imgs/Logo.png"
                alt="789BET Logo"
                sx={{ width: { xs: 250, md: 300 }, mb: 1 }}
            />

            {/* 🔸 Text below logo */}
            <Box
                component="img"
                draggable="false"
                src="/imgs/Text.png"
                alt="กรอก CODE ฟรี และลุ้นรับโบนัสสุดพิเศษจากทางเว็บ!"
                sx={{ width: 320, mb: 3 }}
            />

            {/* 🔸 Form box */}
            <PromoCodeForm />
        </Box>
    );
};

export default PromoRightForm;
